// ABOUTME: Controller Stimulus para pré-matrícula — busca dados de pessoa por CPF.
// ABOUTME: Preenche automaticamente nome e email quando o CPF pertence a pessoa já cadastrada.

import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["cpf", "nomeCivil", "nomeSocial", "email"];
  static values = { url: String };

  get #personFields() {
    return [this.nomeCivilTarget, this.nomeSocialTarget, this.emailTarget];
  }

  async cpfChange(e) {
    const cpf = this.cpfTarget.value.replace(/\D/g, '');
    if (cpf.length < 11) return;

    this.#personFields.forEach(f => f.disabled = true);

    try {
      const response = await get(`${this.urlValue}?cpf=${cpf}`, { responseKind: "json" });
      if (response.ok) {
        const personInfo = await response.json;
        this.nomeCivilTarget.value = personInfo.nome_civil;
        this.nomeSocialTarget.value = personInfo.nome_social;
        this.emailTarget.value = personInfo.email;
      } else {
        this.#personFields.forEach(f => f.value = '');
      }
    } finally {
      this.#personFields.forEach(f => f.disabled = false);
    }
  }
}
